(function() {
  "use strict";

  function onVariantChange(evt) {
    var scope = evt.target && evt.target.closest && evt.target.closest("[data-section-id]") || document,
      holder = scope.querySelector("[data-cl-stock]"),
      variant = evt.detail && evt.detail.variant;
    if (holder) {
      for (var lines = holder.querySelectorAll("[data-cl-stock-for]"), i = 0; i < lines.length; i++) {
        var match = variant && String(lines[i].dataset.clStockFor) === String(variant.id);
        lines[i].hidden = !match;
      }
      markSizes(scope, variant);
    }
  }

  document.addEventListener("variantChange", onVariantChange);
  document.addEventListener("variant:change", onVariantChange);

  var MAX_LOW_DOTS = 3;

  function inventoryMap(scope) {
    var el = (scope || document).querySelector("[data-cl-inventory]");
    if (!el) return null;
    if (el._parsed) return el._parsed;
    try {
      el._parsed = JSON.parse(el.textContent);
    } catch (e) {
      el._parsed = null;
    }
    return el._parsed;
  }

  function markSizes(scope, variant) {
    scope = scope || document;
    var map = inventoryMap(scope);
    if (!(!map || !map.variants)) {
      var sizeIndex = map.sizeIndex;
      if (sizeIndex != null) {
        for (var current = variant || map.variants.filter(function(v2) { return v2.id === map.currentId })[0],
          otherOpts = current && current.options || [],
          labels = scope.querySelectorAll(".variant-input-wrap label.variant__button-label:not(.color-swatch)"),
          lowCandidates = [],
          i = 0; i < labels.length; i++) {
          var label = labels[i],
            value = (label.textContent || "").trim();
          label.removeAttribute("data-cl-level");
          var halo = label.querySelector(".cl-dot-pulse");
          if (halo) halo.remove();
          for (var hit = null, v = 0; v < map.variants.length; v++) {
            var cand = map.variants[v];
            if (cand.options[sizeIndex] === value) {
              for (var sameOtherwise = !0, o = 0; o < cand.options.length; o++) {
                if (o !== sizeIndex && otherOpts[o] && cand.options[o] !== otherOpts[o]) {
                  sameOtherwise = !1;
                }
              }
              if (sameOtherwise) {
                hit = cand;
                break;
              }
            }
          }
          if (hit) {
            if (hit.available) {
              if (hit.tracked && hit.qty > 0 && hit.qty <= map.threshold) {
                lowCandidates.push({ label: label, qty: hit.qty });
              }
            } else {
              label.setAttribute("data-cl-level", "out");
            }
          }
        }
        lowCandidates.sort(function(a, b) { return a.qty - b.qty });
        for (var c = 0; c < lowCandidates.length && c < MAX_LOW_DOTS; c++) {
          var lbl = lowCandidates[c].label;
          lbl.setAttribute("data-cl-level", "low");
          var dot = document.createElement("span");
          dot.className = "cl-dot-pulse";
          dot.setAttribute("aria-hidden", "true");
          lbl.appendChild(dot);
        }
      }
    }
  }

  function initSizes() {
    for (var scopes = document.querySelectorAll("[data-cl-inventory]"), i = 0; i < scopes.length; i++) {
      markSizes(scopes[i].closest("[data-section-id]") || document, null);
    }
  }

  document.addEventListener("shopify:section:load", initSizes);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSizes);
  } else {
    initSizes();
  }

  var SC_GREY = "#f8f8f8",
    SC_LINE = "#e7e7e7";

  function tidyProse(root) {
    if (!(!root || root.dataset.clTidied)) {
      root.dataset.clTidied = "1";
      for (var blocks = root.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6"), i = blocks.length - 1; i >= 0; i--) {
        var el = blocks[i];
        if (!el.classList.contains("cl-size-note") && !el.querySelector("table, img, svg, input, select")) {
          if ((el.textContent || "").replace(/Â /g, " ").trim() === "") {
            el.remove();
          }
        }
      }
      for (var brs = root.querySelectorAll("br"), b = 0; b < brs.length; b++) {
        for (var br = brs[b], prev = br.previousSibling; prev && prev.nodeType === 3 && !prev.textContent.trim();) {
          prev = prev.previousSibling;
        }
        for (var next = br.nextSibling; next && next.nodeType === 3 && !next.textContent.trim();) {
          next = next.nextSibling;
        }
        var prevIsBr = prev && prev.nodeType === 1 && prev.tagName === "BR";
        if (!prev || !next || prevIsBr) {
          br.remove();
        }
      }
    }
  }

  function restyleSizeCharts() {
    for (var proseRoots = document.querySelectorAll(".tool-tip-trigger__content, tool-tip[data-tool-tip] .tool-tip__content"), q = 0; q < proseRoots.length; q++) {
      tidyProse(proseRoots[q]);
    }
    for (var tables = document.querySelectorAll(".tool-tip-trigger__content table, tool-tip[data-tool-tip] table"), t = 0; t < tables.length; t++) {
      var table = tables[t];
      if (!table.dataset.clRestyled) {
        table.dataset.clRestyled = "1";
        for (var cells = table.querySelectorAll("th, td"), c = 0; c < cells.length; c++) {
          cells[c].style.setProperty("border", "0", "important");
          cells[c].style.setProperty("border-bottom", "1px solid " + SC_LINE, "important");
        }
        for (var ths = table.querySelectorAll("th"), h = 0; h < ths.length; h++) {
          ths[h].style.setProperty("background-color", "#1c1917", "important");
          ths[h].style.setProperty("color", "#ffffff", "important");
          ths[h].style.setProperty("border-bottom", "0", "important");
        }
        for (var rows = table.querySelectorAll("tr"), dataIndex = 0, r = 0; r < rows.length; r++) {
          var tds = rows[r].querySelectorAll("td");
          if (tds.length) {
            for (var bg = dataIndex % 2 === 1 ? SC_GREY : "#ffffff", d = 0; d < tds.length; d++) {
              tds[d].style.setProperty("background-color", bg, "important");
            }
            dataIndex++;
          }
        }
        makeScrollable(table);
      }
    }
  }

  function makeScrollable(table) {
    var parent = table.parentNode;
    if (!(!parent || (parent.className || "").indexOf("cl-sizechart-scroll") > -1)) {
      var frame = document.createElement("div");
      frame.className = "cl-sizechart-frame";
      frame.style.cssText = "position:relative;max-width:100%;";
      var wrap = document.createElement("div");
      wrap.className = "cl-sizechart-scroll";
      wrap.style.cssText = "overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;max-width:100%;";
      parent.insertBefore(frame, table);
      frame.appendChild(wrap);
      wrap.appendChild(table);
      for (var cells = table.querySelectorAll("th, td"), i = 0; i < cells.length; i++) {
        cells[i].style.setProperty("white-space", "nowrap", "important");
      }
      for (var rows = table.querySelectorAll("tr"), r = 0; r < rows.length; r++) {
        var first = rows[r].children[0];
        if (first) {
          var bg = first.style.backgroundColor || (first.tagName === "TH" ? "#1c1917" : "#ffffff");
          first.style.setProperty("position", "sticky", "important");
          first.style.setProperty("left", "0", "important");
          first.style.setProperty("z-index", "2", "important");
          first.style.setProperty("background-color", bg, "important");
          first.style.setProperty("box-shadow", "1px 0 0 0 " + SC_LINE, "important");
        }
      }
    }
  }

  document.addEventListener("shopify:section:load", restyleSizeCharts);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restyleSizeCharts);
  } else {
    restyleSizeCharts();
  }

  function markScrollers() {
    for (var wraps = document.querySelectorAll(".cl-sizechart-scroll"), i = 0; i < wraps.length; i++) {
      (function(w) {
        var frame = w.parentElement;
        if (frame) {
          var over = w.scrollWidth - w.clientWidth > 2;
          frame.classList.toggle("is-scrollable", over);
          if (over && !w.dataset.clBound) {
            w.dataset.clBound = "1";
            w.addEventListener("scroll", function() {
              frame.classList.toggle("is-at-end", w.scrollLeft + w.clientWidth >= w.scrollWidth - 2);
            }, { passive: !0 });
          }
        }
      })(wraps[i]);
    }
  }

  document.addEventListener("click", function(e) {
    if (e.target.closest && e.target.closest("tool-tip-trigger, [data-tool-tip], .tool-tip-trigger")) {
      setTimeout(function() {
        restyleSizeCharts();
        markScrollers();
      }, 250);
      setTimeout(markScrollers, 900);
    }
  }, !0);

  window.addEventListener("resize", markScrollers, { passive: !0 });

  function tiers(el) {
    var raw = (el.getAttribute("data-cl-tiers") || "2:10,3:15,4:20").split(",");
    return raw.map(function(pair) {
      var bits = pair.split(":");
      return { at: parseInt(bits[0], 10), pct: parseInt(bits[1], 10) };
    }).filter(function(t) { return t.at && t.pct });
  }

  function ladderPct(units, stops) {
    var step = 100 / stops.length;
    if (units >= stops[stops.length - 1]) return 100;
    for (var i = stops.length - 1; i >= 0; i--) {
      if (units >= stops[i]) {
        var frac = (units - stops[i]) / (stops[i + 1] - stops[i]);
        return (i + 1 + frac) * step;
      }
    }
    return units / stops[0] * step;
  }

  function replay(el, cls) {
    if (el) {
      el.classList.remove(cls);
      el.offsetWidth;
      el.classList.add(cls);
    }
  }

  function paint(root, units) {
    var list = tiers(root),
      stops = list.map(function(t) { return t.at }),
      fill = root.querySelector("[data-cl-fill]");
    if (fill) {
      fill.style.width = ladderPct(units, stops) + "%";
    }
    for (var nodes = root.querySelectorAll("[data-cl-node]"), i = 0; i < nodes.length; i++) {
      var hit = list[i] && units >= list[i].at,
        was = nodes[i].classList.contains("is-hit");
      nodes[i].classList.toggle("is-hit", !!hit);
      if (hit && !was) replay(nodes[i], "is-just-hit");
      if (!hit) nodes[i].classList.remove("is-just-hit");
    }
    root.classList.toggle("cl-ladder-empty", !units);
    var msg = root.querySelector("[data-cl-msg]");
    if (msg) {
      for (var next = null, pct = 0, j = 0; j < list.length; j++) {
        if (units >= list[j].at) {
          pct = list[j].pct;
        } else if (!next) {
          next = list[j];
        }
      }
      if (!units) {
        msg.innerHTML = "Add <b>" + list[0].at + " items</b> and save <b>" + list[0].pct + "%</b>";
      } else if (next) {
        var away = next.at - units;
        msg.innerHTML = (pct ? "<b>" + pct + "% off</b> unlocked! " : "Great job! ") +
          "Add <b>" + away + " more</b> for <b>" + next.pct + "% off</b>";
      } else {
        msg.innerHTML = "<b>" + pct + "% off</b> unlocked — that's the best we do";
      }
    }
    var gift = root.querySelector("[data-cl-gift]");
    if (gift) {
      var at = parseInt(gift.getAttribute("data-cl-gift-at"), 10) || 0,
        unlocked = at > 0 && units >= at,
        wasUnlocked = gift.classList.contains("is-unlocked");
      gift.classList.toggle("is-unlocked", unlocked);
      if (unlocked && !wasUnlocked) replay(gift, "is-just-unlocked");
      if (!unlocked) gift.classList.remove("is-just-unlocked");
      var state = gift.querySelector("[data-cl-gift-state]");
      if (state) {
        state.textContent = unlocked ? "Added free to your order" : "Yours free at " + at + " items";
      }
    }
  }

  function unitsFromCart(cart) {
    return cart && typeof cart.item_count == "number" ? cart.item_count : 0;
  }

  function paintAll(units) {
    for (var roots = document.querySelectorAll("[data-cl-ladder]"), i = 0; i < roots.length; i++) {
      paint(roots[i], units);
    }
  }

  function readCart() {
    return fetch(window.theme && theme.routes ? theme.routes.cart + "?_=" + Date.now() : "/cart.js", { credentials: "same-origin" })
      .then(function(r) { return r.json() });
  }

  function boot() {
    if (document.querySelector("[data-cl-ladder]")) {
      readCart().then(function(cart) {
        paintAll(unitsFromCart(cart));
      }).catch(function() {});
    }
  }

  document.addEventListener("cl:ladder-units", function(e) {
    if (e.detail && typeof e.detail.units == "number") {
      paintAll(e.detail.units);
    }
  });

  document.addEventListener("cart:updated", function(e) {
    if (e.detail && e.detail.cart) {
      paintAll(unitsFromCart(e.detail.cart));
    } else {
      readCart().then(function(c) {
        paintAll(unitsFromCart(c));
      }).catch(function() {});
    }
  });

  document.addEventListener("cart:build", boot);
  document.addEventListener("shopify:section:load", boot);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function initProof() {
    for (var hosts = document.querySelectorAll("[data-cl-proof]"), h = 0; h < hosts.length; h++) {
      (function(host) {
        if (host.dataset.clBound) return;
        host.dataset.clBound = "1";
        var items = host.querySelectorAll("[data-cl-proof-item]");
        if (items.length < 2) return;
        var i = 0,
          timer = null;

        function go() {
          items[i].classList.remove("is-on");
          i = (i + 1) % items.length;
          items[i].classList.add("is-on");
        }

        function play() {
          stop();
          timer = setInterval(go, 6500);
        }

        function stop() {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        }
        host.addEventListener("mouseenter", stop);
        host.addEventListener("mouseleave", play);
        play();
      })(hosts[h]);
    }
  }

  document.addEventListener("shopify:section:load", initProof);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProof);
  } else {
    initProof();
  }

  var rewardHasItems = !1;

  function rewardVisible(bar, inGrid) {
    bar.classList.toggle("is-on", !!(inGrid && rewardHasItems));
  }

  function initReward() {
    var bar = document.querySelector("[data-cl-reward]");
    if (!bar || bar.dataset.clBound) return;
    var target = document.querySelector(bar.getAttribute("data-cl-reward-after") || "#CollectionSection") ||
      document.querySelector(".collection-grid, main");
    bar.dataset.clBound = "1";
    var inGrid = !1;

    function sync() {
      rewardVisible(bar, inGrid);
    }
    if (!target || !("IntersectionObserver" in window)) {
      inGrid = !0;
    } else {
      new IntersectionObserver(function(entries) {
        inGrid = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
        sync();
      }, { threshold: 0, rootMargin: "-10% 0px -20% 0px" }).observe(target);
    }
    document.addEventListener("cl:ladder-units", function(e) {
      var n = e && e.detail && typeof e.detail.units == "number" ? e.detail.units : null;
      if (n !== null) {
        rewardHasItems = n > 0;
        sync();
      }
    });

    function readCart2() {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function(r) { return r.json() })
        .then(function(c) {
          rewardHasItems = (c.item_count || 0) > 0;
          sync();
        })
        .catch(function() {});
    }
    document.addEventListener("cart:updated", readCart2);
    document.addEventListener("cart:xhr-updated", readCart2);
    document.addEventListener("ajaxProduct:added", readCart2);
    readCart2();
    sync();
  }

  document.addEventListener("shopify:section:load", initReward);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReward);
  } else {
    initReward();
  }

  var ATC_BTN = 'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] input[name="add"], form[action*="/cart/add"] [type="submit"]',
    ATC_PRICE = ".product-single__price, [data-product-price]";

  function realAddButton() {
    for (var all = document.querySelectorAll(ATC_BTN), i = 0; i < all.length; i++) {
      if (!all[i].closest(".modal, .quick-product__modal, [data-cl-satc]")) {
        return all[i];
      }
    }
    return null;
  }

  function syncPrice(bar) {
    var dest = bar.querySelector("[data-cl-satc-price]");
    if (dest) {
      var now = document.querySelector("[data-product-price]") || document.querySelector(".product-single__price");
      if (now) {
        var html = '<span class="cl-satc__now">' + now.textContent.trim() + "</span>";
        var was = document.querySelector("[data-compare-price]") || document.querySelector(".product__price--compare");
        if (was) {
          var wasText = was.textContent.trim(),
            shown = was.offsetParent !== null || getComputedStyle(was).display !== "none";
          if (wasText && shown) {
            html += '<span class="cl-satc__was">' + wasText + "</span>";
          }
        }
        dest.innerHTML = html;
      }
    }
  }

  function initStickyAtc() {
    var bar = document.querySelector("[data-cl-satc]");
    if (!bar || bar.dataset.clBound) return;
    var anchor = realAddButton();
    if (!anchor) return;
    bar.dataset.clBound = "1";
    bar.querySelector("[data-cl-satc-add]").addEventListener("click", function() {
      var target = document.querySelector(".product-single__meta, .product__form, form[action*='/cart/add']") || realAddButton();
      if (target) {
        var top = window.pageYOffset + target.getBoundingClientRect().top;
        var header = document.querySelector(".site-header, [data-header-height]");
        if (header) {
          top -= header.getBoundingClientRect().height + 12;
        }
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }
    });
    document.addEventListener("variant:change", function(e) {
      var v = e.detail && e.detail.variant;
      syncPrice(bar);
      var img = bar.querySelector("[data-cl-satc-img]");
      if (img && v && v.featured_image && v.featured_image.src) {
        img.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2");
      }
      var add = bar.querySelector("[data-cl-satc-add]");
      if (add) {
        add.disabled = !!(v && v.available === !1);
      }
    });
    var ticking = !1;

    function apply() {
      ticking = !1;
      var btn = realAddButton();
      if (btn) {
        var gone = btn.getBoundingClientRect().bottom < 0;
        bar.classList.toggle("is-on", gone);
        bar.setAttribute("aria-hidden", gone ? "false" : "true");
        document.body.classList.toggle("cl-has-satc", gone);
        if (gone) {
          var h = Math.round(bar.getBoundingClientRect().height);
          if (h && h !== lastH) {
            lastH = h;
            document.documentElement.style.setProperty("--cl-satc-h", h + "px");
          }
        }
      }
    }
    var lastH = 0;

    function onScroll() {
      if (!ticking) {
        ticking = !0;
        window.requestAnimationFrame(apply);
      }
    }
    window.addEventListener("scroll", onScroll, { passive: !0 });
    window.addEventListener("resize", onScroll, { passive: !0 });
    apply();
  }

  document.addEventListener("shopify:section:load", initStickyAtc);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyAtc);
  } else {
    initStickyAtc();
  }

})();